export default function Rust_Syntax() {
  return (
    <div>
      <h1>Rust_Syntax Component</h1>
      <p>This is the Rust_Syntax page.</p>
    </div>
  );
}
